import { useState, useEffect } from 'react';
import { safeParseJSONString } from "../logic/Utils";

const defaultValue = false;

export function useCookiePreference(key) {
    const cookiesEnabled = navigator.cookieEnabled;

    const [value, setValue] = useState(
        getCookiePreferenceOrDefault()
    );

    useEffect(() => {
        if (!cookiesEnabled) return;
        if (value)
            localStorage.setItem(key, JSON.stringify(value));
        else
            localStorage.removeItem(key);
    }, [key, value]);

    function getCookiePreferenceOrDefault() {
        if (!cookiesEnabled) return defaultValue;
        const stored = localStorage.getItem(key);
        if (!stored) {
            return defaultValue;
        }
        return safeParseJSONString(stored);
    }

    return [value, setValue];
}